import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { SearchProduct } from '../redux/slices/SearchProductSlice';
import { FiShoppingCart } from "react-icons/fi";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { CustomeStyle } from '../Css/CustomeStyle';
import { AddWishlist } from '../redux/slices/AddWishlistSlice';
import NoData from "../assets/NoData.png"
import LoaderPage from './Loader';

function SearchProductResult() {
    const location = useLocation();
    const dispatch = useDispatch();
    const { SeachProductData } = useSelector((state) => state.searchData);
    const [loading, setLoading] = useState(false)
    const [likedProducts, setLikedProducts] = useState(new Set());

    const query = new URLSearchParams(location.search).get('query');

    useEffect(() => {
        const fetchData = async () => {
            if (query) {
                setLoading(true);
                try {
                    await dispatch(SearchProduct(query));
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchData();
    }, [query, dispatch]);


    const generateSlug = (text) => {
        if (!text) return "";

        return text
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\- ]/g, "")
            .replace(/\s+/g, "-")
            .replace(/-+/g, "-");
    };

    const toggleLike = (productId) => {
        dispatch(AddWishlist(productId));
        setLikedProducts((prevLikedProducts) => {
            const updatedLikes = new Set(prevLikedProducts);
            if (updatedLikes.has(productId)) {
                updatedLikes.delete(productId);
            } else {
                updatedLikes.add(productId);
            }
            return updatedLikes;
        });
    };

    const products = SeachProductData?.products ? SeachProductData?.products : [];

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4 text-center">Search Results for "{query}"</h1>
            {loading ? (
                <LoaderPage />
            ) : products.length > 0 ? (
                <div className="w-[100%] sm:w-[95%] md:w-[100%]">
                    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-1 lg:gap-3 mt-4">
                        {products?.slice(0, 60).map((item) => (
                            <div
                                key={item._id}
                                className="bg-white shadow rounded-md overflow-hidden relative border border-gray-200 sm:px-5 sm:py-3 px-3 py-2 hover:scale-105 hover:-translate-y-1"
                            >
                                <img
                                    loading="lazy"
                                    src={item?.images?.productimage1}
                                    alt={item.name}
                                    className="w-full h-20 sm:h-40 object-contain bg-light rounded-x"
                                />
                                <button
                                    className="like-btn absolute top-2 left-2"
                                    onClick={() => toggleLike(item._id)}
                                >
                                    {likedProducts.has(item._id) ? (
                                        <FaHeart size="24px" className="text-red-500 sm:text-lg text-xs" />
                                    ) : (
                                        <FaRegHeart size="24px" className="text-gray-400 sm:text-lg md:text-xs" />
                                    )}
                                </button>
                                {item?.outOfStock ? <span className=" absolute bg-gray-200 top-2 right-2  p-1  text-red-500 text-bold text-gray-400 sm:ml-20 ml-0">
                                    Out of stock
                                </span> :
                                    <button className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50">
                                        <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
                                    </button>
                                }
                                <Link
                                    to={`/shop/${item?.category ? generateSlug(item.category) : "-"
                                        }/${item?.subcategory ? generateSlug(item.subcategory) : "-"
                                        }/${generateSlug(item.title)}`}
                                    state={{ item }}
                                    className="block"
                                >
                                    <div className="mb-1 end-2 lg:mt-3">
                                        <h2 className="sm:text-xl text-xs text-black from-neutral-600 sm:mt-0 mt-3">
                                            {item.name}
                                        </h2>
                                        <h2
                                            style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                textAlign: "center",
                                            }}
                                            className={CustomeStyle.title}
                                        >
                                            {item.title}
                                        </h2>
                                        <div>
                                            <span className={CustomeStyle.description}>
                                                {item.description}
                                            </span>
                                        </div>
                                        <div className="flex items-center justify-center gap-1">
                                            <span className={CustomeStyle.text}>₹{item?.salePrice}</span>
                                            <span className={`${CustomeStyle.text} line-through`}>
                                                ₹{item?.regularPrice}
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="text-center text-gray-500 mt-4 flex flex-col items-center">
                    <img
                        src={NoData}
                        alt="No Data Found"
                        className="w-48 h-48 object-contain mb-4"
                    />
                </div>
            )}
        </div>
    );
}

export default SearchProductResult;